import $ from "jquery";

document.addEventListener("DOMContentLoaded", function(event) {
    $('select[name=license]').on('change', function() {
        $('.license-select-block').each(function(){
            if($(this).data('license') == $('select[name=license]').val()) {
                $(this).prop('hidden', false);
            }
            else {
                $(this).prop('hidden', true);
            }
        });
    });
});